import React from 'react';
import Fifthgrade_k5 from './fifthgrade_k5';
import Fifthgrade_k5_subjects from './fifthgrade_k5_subjects';
const Fifthgrade_k5eng = () => {
  return (
    <div>
      <Fifthgrade_k5 />
    <Fifthgrade_k5_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>English section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Fifthgrade_k5eng;